import { ExamEventYearSelection, MonthlyExamEventList } from '@exam-center/monthly-exam-event-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Box, Flex, Paper } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ExamEventsByYearPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <Flex
        sx={(theme) => ({
          bgcolor: theme.palette.grey[50],
          flexDirection: 'column',
          height: '100dvh',
          width: '100%',
        })}
      >
        {/* Content */}
        <Flex sx={{ p: (theme) => theme.spacing(6), flexGrow: 1, width: '100%' }}>
          <Paper
            sx={(theme) => ({
              borderRadius: theme.shape.rounded(2),
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing(6),
              height: '100%',
              padding: theme.spacing(6),
              width: '100%',
            })}
          >
            <Box sx={{ maxWidth: '260px', width: '100%' }}>
              <ExamEventYearSelection />
            </Box>
            <Box>
              <MonthlyExamEventList />
            </Box>
          </Paper>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
